<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-04-20 10:56:53
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-05-19 14:38:43
-->
<template>
  <div class="teacher-list">
    <table-list
      class="tableList"
      title="授课视频列表"
      :loading="loading"
      :search-form="searchForm"
      :data="lectureVideoList"
      :columns="columns(this)"
      :operates="operates(this)"
      :btns="btns(this)"
      :options="{ selection: true }"
      :pager="pager"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <Video
      :id="this.$route.query.teacherId"
      ref="video"
      :name="this.$route.query.teacherName"
      @success="lectureVideoListData()"
    ></Video>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '添加视频',
    method: _this.handleAdd,
  },
  {
    label: '删除',
    method: _this.handleDelete,
    type: 'danger',
  },
]
// 搜索框配置
const searchForm = [
  {
    label: '视频名称',
    prop: 'videoName',
  },
  {
    label: '上传时间',
    type: 'picker',
    prop: 'dateTime',
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'videoName',
    label: '视频名称',
  },
  {
    prop: 'videoPic',
    label: '视频封面',
    render: (h, { row }) => {
      return [
        row.videoPic
          ? h('img', {
              domProps: { src: row.videoPic },
              style: 'height:80px;width:80px;',
            })
          : null,
      ]
    },
  },
  {
    prop: 'videoDurationHHMMSS',
    label: '视频时长',
  },
  {
    prop: 'teacherName',
    label: '授课讲师',
  },
  {
    prop: 'createTime',
    label: '创建时间',
  },
  {
    label: '可用状态',
    render: (h, { row }) => {
      return [
        h('el-switch', {
          props: { value: row.status, activeValue: true, inactiveValue: false },
          on: {
            change: async v => {
              await _this.handleOpen(v, row)
            },
          },
        }),
      ]
    },
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    label: '编辑',
    method: _this.handleEdit,
  },
]
import TableList from '@/components/TableList'
import Video from './components/video.vue'
import { videoDeleteBatch, videoChangeStatus, lectureVideoList } from '@/api/teacher'
import to from 'await-to'
export default {
  components: {
    TableList,
    Video,
  },
  data() {
    return {
      btns,
      searchForm,
      columns,
      operates,
      loading: false,
      lectureVideoList: [],
      selectTeachers: [],
      queryParams: {},
      pager: {
        total: 0,
        size: 10,
        current: 1,
        teacherId: this.$route.query.teacherId,
      },
    }
  },
  mounted() {
    this.lectureVideoListData()
  },
  methods: {
    async lectureVideoListData() {
      if (this.loading) return
      const { current, size, teacherId } = this.pager
      this.loading = true
      const [res, err] = await to(
        lectureVideoList({ current, size, teacherId, ...this.queryParams }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.lectureVideoList = res.data.list
      this.pager.total = res.data.total
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      if (queryParams.dateTime) {
        queryParams.beginTime = queryParams.dateTime[0]
        queryParams.endTime = queryParams.dateTime[1]
      } else {
        queryParams.beginTime = ''
        queryParams.endTime = ''
      }
      this.queryParams = queryParams
      this.lectureVideoListData()
    },
    //设置对外开放
    async handleOpen(v, row) {
      console.log(v)
      const [, err] = await to(
        videoChangeStatus({ teachingVideoId: row.teachingVideoId, status: row.status }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('成功')
      this.lectureVideoListData()
    },
    handleAdd() {
      this.$refs.video.show()
    },
    // 删除
    handleDelete() {
      if (!this.selectTeachers.length) return this.$message.warning('请先选择要删除的讲师')
      let teachingVideoIds = []
      this.selectTeachers.map(item => teachingVideoIds.push(item.teachingVideoId))
      this.$confirm('确认删除讲师吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [, err] = await to(videoDeleteBatch({ teachingVideoIds }))
        if (err) return this.$message.warning(err.msg)
        this.$message.success('删除成功')
        this.lectureVideoListData()
      })
    },
    // 编辑
    handleEdit(row) {
      this.$refs.video.show(row.teachingVideoId)
    },
    // 多选
    handleSelectionChange(val) {
      this.selectTeachers = val
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.lectureVideoListData()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.lectureVideoListData()
    },
  },
}
</script>
<style lang="scss" scoped>
.teacher-list {
  tr {
    &:last-of-type {
      width: 300px;
    }
  }
  ::v-deep .operate-group {
    // width: 50%;
    // float: left;
    span {
      // display: block;
      margin: 0 3px;
    }
  }
  .tableList ::v-deep .el-table tr .courseIntroduction {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }
}
</style>
